import { RevenueByMonth } from 'services/requests';
import { formatMonthAndYear, formatUSD } from 'utils';
import { CustomColumn } from 'components/Table/Table.types';

import styles from './EtzProfileRevenueTable.module.css';

export type EtzRevenueTableSign = Omit<
  RevenueByMonth,
  | 'month'
  | 'year'
  | 'totalRevenue'
  | 'transactionRevenue'
  | 'annualFeeRevenue'
  | 'withdrawalFeeRevenue'
> & {
  monthAndYear: string;
  totalRevenue: string;
  transactionRevenue: string;
  annualFeeRevenue: string;
  withdrawalFeeRevenue: string;
};

export type MapData = EtzRevenueTableSign[];

export const mapData = (data: RevenueByMonth[] | undefined): MapData | undefined =>
  data?.map((revenueByMonth: RevenueByMonth) => ({
    ...revenueByMonth,
    monthAndYear: formatMonthAndYear(revenueByMonth.month, revenueByMonth.year),
    totalRevenue: formatUSD(revenueByMonth.totalRevenue),
    transactionRevenue: formatUSD(revenueByMonth.transactionRevenue),
    annualFeeRevenue: formatUSD(revenueByMonth.annualFeeRevenue),
    withdrawalFeeRevenue: formatUSD(revenueByMonth.withdrawalFeeRevenue),
  }));

type Columns = CustomColumn<EtzRevenueTableSign>[];
export const columns: Columns = [
  {
    Header: 'Month, year',
    accessor: 'monthAndYear',
    className: styles.monthYearColumn,
  },
  {
    Header: 'Total',
    accessor: 'totalRevenue',
    className: styles.totalColumn,
  },
  {
    Header: 'Transaction revenue',
    accessor: 'transactionRevenue',
    className: styles.transactionRevenueColumn,
  },
  {
    Header: 'Annual fee revenue',
    accessor: 'annualFeeRevenue',
    className: styles.annualFeeRevenueColumn,
  },
  {
    Header: 'Withdrawal fee revenue',
    accessor: 'withdrawalFeeRevenue',
    className: styles.withdrawalFeeRevenueColumn,
  },
];
